import { Link } from "react-router-dom";
import { MEDIA } from "../../constants/media";
import { slugify } from "../../lib/utils";
import { MapPin, ArrowRight } from "lucide-react";

const CITIES = [
  { name: "Lisboa", region: "Lisboa", desc: "A capital das oportunidades" },
  { name: "Porto", region: "Porto", desc: "O motor do norte" },
  { name: "Braga", region: "Braga", desc: "Jovem e dinâmica" },
  { name: "Almada", region: "Setúbal", desc: "Margem sul de Lisboa" },
  { name: "Amadora", region: "Lisboa", desc: "Corazão da Grande Lisboa" },
  { name: "Matosinhos", region: "Porto", desc: "Mar e indústría" },
];

export const Cities = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
    <div className="grid lg:grid-cols-5 gap-6 items-stretch">
      {/* Left: big image + heading */}
      <div className="lg:col-span-2 relative rounded-3xl overflow-hidden min-h-[300px]">
        <img src={MEDIA.lisbon} alt="Lisboa, Portugal" loading="lazy"
          className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/50 to-slate-950/10" />
        <div className="absolute bottom-0 left-0 p-7">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-amber-400 mb-2">Cidades com vagas</p>
          <h2 className="font-heading font-black tracking-tighter text-2xl sm:text-3xl text-white leading-tight">
            Trabalha onde queres
          </h2>
          <p className="text-slate-400 text-sm mt-2 max-w-xs">
            De Lisboa ao Porto, de Braga ao Algarve — cobrimos 308 concelhos.
          </p>
          <Link to="/empregos"
            className="inline-flex items-center gap-1.5 mt-5 bg-amber-400 hover:bg-amber-300 text-slate-950 font-bold rounded-full px-5 py-2 text-sm transition-colors">
            Ver todas as vagas <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>

      {/* Right: city grid */}
      <div className="lg:col-span-3 grid grid-cols-2 sm:grid-cols-3 gap-3">
        {CITIES.map((c) => (
          <Link key={c.name} to={`/empregos-em/${slugify(c.name)}`}
            className="group bg-white border border-black/5 rounded-2xl p-5 hover:border-amber-400 hover:shadow-md hover:-translate-y-0.5 transition-all">
            <div className="flex items-center gap-2 mb-2">
              <MapPin className="w-4 h-4 text-amber-500 shrink-0" strokeWidth={1.5} />
              <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">{c.region}</span>
            </div>
            <p className="font-heading font-black tracking-tighter text-lg text-slate-900 group-hover:text-amber-600 transition-colors">
              {c.name}
            </p>
            <p className="text-xs text-slate-500 mt-1">{c.desc}</p>
            <p className="flex items-center gap-1 text-xs text-amber-600 font-medium mt-3 opacity-0 group-hover:opacity-100 transition-opacity">
              Ver vagas <ArrowRight className="w-3 h-3" />
            </p>
          </Link>
        ))}
      </div>
    </div>
  </section>
);
